// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mail-message-has-mdn-request[data-v-26bdaf82]{white-space:normal}`, "",{"version":3,"sources":["webpack://./src/components/MdnRequest.vue"],"names":[],"mappings":"AACA,+CACC,kBAAA","sourcesContent":["\n.mail-message-has-mdn-request {\n\twhite-space: normal;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
